import { useTranslation } from "react-i18next";
import { PaperBillDownloadButton } from "@pages/BillsPage/components/BillsPayment/components/PaperBillPaymentModal/components/PaperBillDownloadButton/PaperBillDownloadButton";
import { Button } from "@components/Button";
import { WalletIcon } from "@components/icons";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";
import { type IPaperBillPayment } from "@services/payments/types";

interface IPaperBillPaymentModalProps extends IUseModalProps {
  payment: IPaperBillPayment;
  periodId: number;
}

export const PaperBillPaymentModal: React.FC<IPaperBillPaymentModalProps> = ({
  payment,
  periodId,
  ...modalProps
}) => {
  const modal = useModal(modalProps);
  const { t } = useTranslation();

  const paperBills = payment.paperBills ?? [];

  return (
    <Modal
      modal={modal}
      actionButtons={
        <div className="flex w-full justify-end">
          <Button
            variant="secondary"
            className="w-full md:w-fit"
            onClick={modal.close}
          >
            {t("paperBillPaymentModal.actions.cancel")}
          </Button>
        </div>
      }
      title={t(`paperBillPaymentModal.title.${payment?.taxCollectorTypeId}`)}
      subtitle={t(
        `paperBillPaymentModal.subtitle.${payment?.taxCollectorTypeId}`,
      )}
      badgeProps={{ icon: WalletIcon }}
    >
      <div className="flex flex-col gap-4">
        {paperBills.map((bill) => (
          <PaperBillDownloadButton paperBill={bill} periodId={periodId} />
        ))}
      </div>
    </Modal>
  );
};
